module.exports = __webpack_public_path__ + "static/img/anxunMobel23.f682e263.png";